import cruzeiroTheme from './cruzeiro.theme';
import ingresseTheme from './ingresse.theme';

const ThemeList = [
  { 1 : ingresseTheme },
  { 7791810 : cruzeiroTheme }
];

export default ThemeList;
